import { Button, Grid, Paper, Stack } from "@mui/material";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { IframeParams } from "../AppointmentManagement/Calendar/ModalReservation/ModalReservation";
import { DataContext } from "../AppointmentManagement/Calendar/Context/ContextWrapper";
import { getConfig } from "../../config/config";
import dayjs from "dayjs";

export type ObjChWb = {
  token: string;
  hideNavigationButtons: boolean;
  mostraAPICard: boolean;
};

const IframeContainer = (props: {
  // dataToSend: any;
  iframeStatus: IframeParams;
  setIframeStatus: (value: IframeParams) => void;
  idPaziente?: string;
}) => {
  const { BASE_URL, ANAGRAFICA_CREATE, ANAGRAFICA_EDIT } = getConfig();
  const context = useContext(DataContext);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  let objSend : ObjChWb =  {
    token: "",
    hideNavigationButtons: true,
    mostraAPICard: false,
  }

  let urlToCall;

  switch (props.iframeStatus.type) {
    case "angrf":
      urlToCall = `${BASE_URL}${ANAGRAFICA_EDIT}${props?.idPaziente ?? ""}`;
      break;

    case "insr":
      urlToCall = `${BASE_URL}${ANAGRAFICA_CREATE}`;
      break;

    case "tssr":
      urlToCall = `${BASE_URL}${ANAGRAFICA_EDIT}${props?.idPaziente ?? ""}`;
      objSend.mostraAPICard = true;
      break;

    default:
      urlToCall = ``;
      break;
  }

  const closeIframe = (event: MessageEvent) => {
    if (event?.data && event.data.chiudiModaleAnagrafica === true) {
      props.setIframeStatus({ type: "", data: event.data, show: false });
      context?.setTimestampAnagrafica({
        firstTimeStamp: context.timestampAnagrafica.firstTimeStamp,
        secondTimeStamp: dayjs().unix(),
      });
    }
  };

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.modaleAnagraficaPronto) {
        iframeRef.current?.contentWindow?.postMessage(objSend, "*");
      }

      console.log("Data:", event.data);
      console.log("Origin:", event.origin);
      console.log("Source:", event.source);

      closeIframe(event);
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <Paper
      sx={{
        display: "flex",
        justifyContent: "center",
        justifyItems: "center",
        width: "100%",
        height: "100%",
        scrollbarWidth: "none",
        scrollMarginRight: "none",
      }}
    >
      <Grid
        container
        direction="column"
        sx={{
          height: "100vh",
          borderRadius: 2,
        }}
        spacing={1}
      >
        {/* <Grid item>
          <Stack direction="row" spacing={1}>
            <Button variant="contained">Invia messaggio all'iframe</Button>
            <Button
              variant="contained"
              onClick={() =>
                props.setIframeStatus({
                  type: "",
                  data: props.iframeStatus.data,
                  show: !props.iframeStatus.show,
                })
              }
            >
              Chiudi Anagrafica
            </Button>
          </Stack>
        </Grid> */}
        <Grid
          item
          sx={{
            flex: 1,
            minHeight: 0,
          }}
        >
          <iframe
            src={urlToCall}
            ref={iframeRef}
            scrolling="no"
            title="IframeApp"
            width="100%"
            height="100%"
            style={{
              border: "1px solid #ccc",
              overflow: "hidden",
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default IframeContainer;
